import ESuranceMembershipContactModelBase from '../_generated/modelBases/e-surance-membership-contact-model-base';

export default class ESuranceMembershipContactModel extends ESuranceMembershipContactModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
